/**
 * @file Switch
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { ViewCheckbox } from '../../views/ViewCheckbox';
import { withCheckedWrapper } from '../../hoc/withCheckedWrapper';
export var Checkbox = withCheckedWrapper('checkbox', ViewCheckbox);